import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import './Blog.css';

const Blog = () => {
  const { t } = useTranslation();
  const [posts, setPosts] = useState([]);
  const [expandedPosts, setExpandedPosts] = useState({});

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192');
        const apiUrl = isLocal ? `http://192.3.10.53:3001/api/blog` : '/api/blog';
        
        const response = await fetch(apiUrl);
        if (response.ok) {
          const data = await response.json();
          // Tarihe göre yeniden eskiye sırala
          const sortedData = data.sort((a, b) => new Date(b.date) - new Date(a.date));
          setPosts(sortedData);
        }
      } catch (error) {
        console.error('Blog fetch error:', error);
      }
    };
    fetchPosts();
  }, []);

  const togglePost = (id) => {
    setExpandedPosts(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const MAX_LENGTH = 300; // Kısaltma karakter sınırı

  // HTML etiketlerini temizleyip sadece metni almak için yardımcı fonksiyon
  const stripHtml = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  return (
    <div className="page blog-page">
      <Helmet>
        <title>{t('blog.title')} - TA2GBO</title>
      </Helmet>
      <h2>{t('blog.title')}</h2>
      
      <div className="blog-list">
        {posts.length > 0 ? (
          posts.map(post => {
            const isExpanded = expandedPosts[post.id];
            const plainText = stripHtml(post.content);
            const shouldTruncate = plainText.length > MAX_LENGTH;
            
            return (
              <article key={post.id} className="blog-post">
                <div className="post-header">
                  <h3>{post.title}</h3>
                  <span className="post-date">{post.date}</span>
                </div>
                <div className="post-content">
                  {isExpanded ? (
                    <div dangerouslySetInnerHTML={{ __html: post.content }} />
                  ) : (
                    <p>
                      {shouldTruncate ? plainText.substring(0, MAX_LENGTH) + '...' : plainText}
                    </p>
                  )}
                </div>
                <div className="post-footer">
                  {shouldTruncate && (
                    <button className="read-more-btn" onClick={() => togglePost(post.id)}>
                      {isExpanded ? 'Daha Az Göster' : 'Devamını Oku'}
                    </button>
                  )}
                  <div className="share-buttons">
                    <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(post.title)}&url=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noopener noreferrer" className="share-btn twitter" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
                    <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noopener noreferrer" className="share-btn facebook" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                    <a href={`https://api.whatsapp.com/send?text=${encodeURIComponent(post.title + ' ' + window.location.href)}`} target="_blank" rel="noopener noreferrer" className="share-btn whatsapp" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>
                  </div>
                </div>
              </article>
            );
          })
        ) : (
          <p className="no-posts">{t('blog.noPosts')}</p>
        )}
      </div>
    </div>
  );
};

export default Blog;
